import {
  createFeatureFlagsContext,
  type FeatureFlag,
} from 'src/libs/FeatureFlags/createFeatureFlagsContext';

export type VerifiedCareerHistoryNoticeFeature = FeatureFlag<
  'cm-sg-verified-career-history-notice',
  'on'
>;

export type JobPlacementExperimentFeature = FeatureFlag<
  'cm_improve_direct_placement_signals',
  'not_yet' | 'too_early_to_say' | 'still_reviewing_applications'
>;

export type HighFitApplicantExplainabilityFeature = FeatureFlag<
  'cm_high_fit_applicant_explainability',
  'challenger'
>;

export type Features =
  | VerifiedCareerHistoryNoticeFeature
  | JobPlacementExperimentFeature
  | HighFitApplicantExplainabilityFeature;

export const { useFeatureFlag, FeatureFlagsProvider, featureKeys } =
  createFeatureFlagsContext<Features>([
    'cm-sg-verified-career-history-notice',
    'cm_improve_direct_placement_signals',
    'cm_high_fit_applicant_explainability',
  ]);
